__turbopack_context__.v({
  "content": "explanation-module-scss-module__2TlHjq__content",
  "icon": "explanation-module-scss-module__2TlHjq__icon",
  "isClickable": "explanation-module-scss-module__2TlHjq__isClickable",
  "popover": "explanation-module-scss-module__2TlHjq__popover",
  "relative": "explanation-module-scss-module__2TlHjq__relative",
  "wrapper": "explanation-module-scss-module__2TlHjq__wrapper",
});
